import type {HelpPages} from "modules/enums";
import type {TStore} from "modules/types/store";
import {createSelector} from "reselect";

export const getHelpStore = (store: TStore) => store.help;

export const getHelpPage = createSelector(
	[getHelpStore],
	(store) => (page: HelpPages) => store[page]
);
